import { useSelector } from "react-redux";

import { RouteDefinition } from "components/router/Routes";
import { MAX_TENANT_LAYER } from "domain/globalConstants";
import { featureFlagService } from "services/feature/FeatureFlagService";
import { getAllTenantsDetails, getCurrentTenantDetails, getTenantLayer } from "services/tenants/tenantCookieService";
import { StoreState } from "store";

export function useIsRouteEnabled() {
    const user = useSelector((state: StoreState) => state.userReducer.user);

    const tenantDetails = getCurrentTenantDetails();
    const tenantLayer = getTenantLayer();
    // Checking count of accessed tenant after user login and "getAllTenantsDetails" will
    // return 1 even if no tenant is accessed, hence subtracting it by 1 for calculation
    const accessedTenantsCount = getAllTenantsDetails().length - 1;

    return (route: RouteDefinition): boolean => {
        if (!route.isValidUser(user)) {
            return false;
        }

        const flag = route.getFeatureFlag();
        if (flag != null && !featureFlagService.isFeatureEnabled(flag)) {
            return false;
        }

        if (
            tenantLayer + accessedTenantsCount == MAX_TENANT_LAYER &&
            tenantDetails.featureLicenses.includes("FEATURE_TENANT_MANAGEMENT")
        ) {
            tenantDetails.featureLicenses.splice(tenantDetails.featureLicenses.indexOf("FEATURE_TENANT_MANAGEMENT"), 1);
        }

        return route.isAccessibleTo(tenantDetails);
    };
}
